var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2804_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7109 1.35351L11.1692 0.0237101C10.321 -0.12586 9.51208 0.440546 9.3625 1.28879L9.29114 1.69359C10.3818 1.82797 11.3032 2.61367 11.5934 3.69629L12.0543 5.41641C12.2983 5.31059 12.5749 5.27246 12.8565 5.32211C13.3907 5.41633 13.8006 5.80082 13.9533 6.28469C14.2623 5.88223 14.779 5.66109 15.3132 5.75531C16.0779 5.89016 16.5885 6.61933 16.4536 7.38398C16.1607 9.04547 14.3777 10.3809 13.5316 10.9302L14.8234 15.7514C14.8927 16.0098 14.9216 16.2696 14.9152 16.5244L16.0021 16.7161C16.8503 16.8656 17.6592 16.2992 17.8088 15.451L19.976 3.16031C20.1256 2.31199 19.5592 1.50309 18.7109 1.35351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4636 3.99935C10.2768 3.30255 9.64673 2.84298 8.9581 2.84302C8.8245 2.84302 8.68864 2.86032 8.55345 2.89653L1.15634 4.87856C0.324348 5.10149 -0.169402 5.95669 0.0535276 6.78868L3.28364 18.8437C3.47036 19.5405 4.10048 20 4.78911 20C4.92271 20 5.05857 19.9827 5.19372 19.9465L12.5908 17.9645C13.4228 17.7415 13.9166 16.8863 13.6936 16.0543L10.4636 3.99935ZM4.70743 12.2396C4.582 12.1293 4.53517 11.9544 4.58861 11.7961L5.7197 8.447C5.81431 8.16685 6.16361 8.07325 6.38564 8.26856L9.03978 10.6035C9.16521 10.7138 9.21204 10.8887 9.15861 11.047L8.02751 14.3961C7.9329 14.6763 7.58361 14.7699 7.36157 14.5745L4.70743 12.2396Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2804_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplit);
export default __webpack_public_path__ + "static/media/split.6bf413eeb1ef7f52c68719cbb2fa4429.svg";
export { ForwardRef as ReactComponent };